import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  convertToTimeZone,
  dateFormatter,
  getEventImageUrl,
} from "../../../utils/Helper";

const getEventStatus = ({ eventTiming, isActive, isCancelled }) => {
  if (
    new Date(eventTiming?.endDate) <
    new Date().setDate(new Date().getDate() - 1)
  ) {
    return { label: "Expired", className: "is-expired" };
  }
  if (isCancelled && !isActive) {
    return { label: "Cancelled", className: "is-cancelled" };
  }
  if (!isActive) {
    return { label: "Draft", className: "is-draft" };
  }
  if (new Date(eventTiming?.startDate) > new Date()) {
    return { label: "Upcoming", className: "is-upcoming" };
  }
  return { label: "Active", className: "is-active" };
};

const PromotingEventCard = ({ event, onShare, onCopyPromo }) => {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const [timezone, setTimeZone] = useState(null);

  const imagePath = event?.mainimage?.[0]?.path || "";
  const imageUrl = imagePath
    ? getEventImageUrl(
        imagePath,
        "https://placehold.co/700x900/0b1020/eaf0ff?text=Event"
      )
    : "https://placehold.co/700x900/0b1020/eaf0ff?text=Event";

  const eventStatus = getEventStatus(event);
  const commission = event?.settings?.settings?.commissionAmount;
  const endDate = event?.eventTiming?.endDate;
  const canShareLink =
    Boolean(endDate) && new Date() <= new Date(endDate);

  useEffect(() => {
    setTimeZone(
      convertToTimeZone(
        new Date(event?.eventTiming?.startDate || new Date()),
        event?.eventTiming?.timeZone || "Asia/Calcutta"
      )
    );
  }, [event?.eventTiming]);

  const startLabel = timezone
    ? `${dateFormatter(event.eventTiming.startDate)} (${timezone})`
    : dateFormatter(event.eventTiming.startDate);

  const endLabel = timezone
    ? `${dateFormatter(event.eventTiming.endDate)} (${timezone})`
    : dateFormatter(event.eventTiming.endDate);

  const openDetails = (clickEvent) => {
    clickEvent.preventDefault();
    navigate(
      `/event-details/${event._id}?referralId=${userDetails?._id}&eventId=${event._id}`
    );
  };

  return (
    <article 
      className="event-promoting-card"
      role="listitem"
      aria-label={event.title}
    >
      <a
        className="event-promoting-card-link"
        href={`/event/event-details/${event._id}`}
        onClick={openDetails}
      >
        <div className="event-promoting-card-media">
          <img
            className="event-promoting-card-image-bg"
            src={imageUrl}
            alt=""
            loading="lazy"
            aria-hidden="true"
          />
          <img
            className="event-promoting-card-image"
            src={imageUrl}
            alt=""
            loading="lazy"
          />
          <span className={`event-created-status ${eventStatus.className}`}>
            {eventStatus.label}
          </span>
          <span className="event-promoting-tag">{event.category}</span>
        </div>
        <div className="event-promoting-card-body">
          <div className="event-promoting-dates">
            <div className="event-promoting-date-row">
              <i className="bi bi-calendar3" aria-hidden="true"></i>
              <span>Start Date : {startLabel}</span>
            </div>
            <div className="event-promoting-date-row">
              <i className="bi bi-calendar3" aria-hidden="true"></i>
              <span>
                End Date :{" "}
                {event.eventTiming?.eventDayType === "multi"
                  ? endLabel
                  : startLabel}
              </span>
            </div>
          </div>
          <h2 className="event-promoting-card-title">{event.title}</h2>
          <div className="event-promoting-location">
            <i className="bi bi-geo-alt" aria-hidden="true"></i>
            <span>{event.location?.address || "—"}</span>
          </div>
          <div className="event-promoting-stats">
            <div className="event-promoting-stat">
              <span className="event-promoting-stat-label">Commission</span>
              <strong className="event-promoting-stat-value">
                {commission != null ? `${commission}%` : "—"}
              </strong>
            </div>
            <div className="event-promoting-stat">
              <span className="event-promoting-stat-label">Tickets Sold</span>
              <strong className="event-promoting-stat-value">
                {event.ticketsSold ?? event.totalTickets ?? 0}
              </strong>
            </div>
            <div className="event-promoting-stat">
              <span className="event-promoting-stat-label">Earnings</span>
              <strong className="event-promoting-stat-value">
                {`USD ${parseFloat(
                  event.earnings ?? event.totalCommission ?? 0
                ).toFixed(2)}`}
              </strong>
            </div>
          </div>
        </div>
      </a>
      {canShareLink && (
        <div className="event-promoting-card-footer">
          <button
            className="event-promoting-btn is-primary"
            type="button"
            onClick={() => onShare(event)}
          >
            Share Link
          </button>
        </div>
      )}
    
    </article>
  );
};

export default PromotingEventCard;
